<template>
  <div class="more-container main-w">
    <Crumbs>
      <template v-slot:current> 查看更多 </template>
    </Crumbs>
    <More :title="title" :news-list="newsList" :page-show="pageShow" @currentPage="currentPage" @toDetail="toDetail">
      <template v-slot:icon>
        <img src="@/assets/search_icon.png" alt="" />
      </template>
    </More>
  </div>
</template>

<script>

import Crumbs from '@/components/Crumbs'
import More from '@/components/More'
export default {
  components: { Crumbs, More },
  data() {
    return {
      title: '行业新闻',
      newsList: {},
      formData: {
        page: 1,
        pagesize: 9
      },
      pageShow: true
    }
  },
    methods: {
    // 获取行业新闻
    async getNewsList() {
      const { data } = await this.service1('News/newsList', { classid: 2, ...this.formData }, 'post')
      this.newsList = data
    },
    currentPage(page) {
      this.formData.page = page
      this.getNewsList()
    },
       // 跳转详情页
    toDetail(id) {
      this.$router.push({ name: 'Detail', params: { id: id } })
    }

  },
  created() {
    this.getNewsList()
  }


}
</script>

<style lang="less" scoped>
.more-container {
  padding: 10px 23px;
  box-sizing: border-box;
  background-color: #fff;
}
</style>